<template>
  <div class="accountSetting">
    <el-container>
      <el-main>
        <div class="screenPanel">
          <el-form ref="form" :model="form" label-width="100px" :inline="true">
            <el-col span="5">
              <el-form-item label="任务名称">
                <el-input v-model="form.DEVICE_CODE"></el-input>
              </el-form-item>
            </el-col>
            <el-col span="5">
              <el-form-item label="执行类名称">
               <el-input v-model="form.DEVICE_CODE"></el-input>
              </el-form-item>
            </el-col>
          </el-form>
          <el-col span="14">
            <div class="handlePanel">
              <el-button type="primary">查询</el-button>
              <el-button type="primary">重置</el-button>
            </div>
          </el-col>
        </div>
        <el-divider></el-divider>
        <el-table
          :data="accountList"
          highlight-current-row
          size="mini"
        >
          <el-table-column prop="userAccnt" label="任务名称" :show-overflow-tooltip="true"></el-table-column>
          <el-table-column prop="userNickName" label="执行类名称" :show-overflow-tooltip="true"></el-table-column>
          <el-table-column prop="userName" label="执行类" :show-overflow-tooltip="true"></el-table-column>
          <el-table-column prop="idCard" label="时间表达式" :show-overflow-tooltip="true"></el-table-column>
          <el-table-column prop="sex" label="启用状态" :show-overflow-tooltip="true"></el-table-column>
          <el-table-column prop="tel" label="运行状态" :show-overflow-tooltip="true"></el-table-column>
          <el-table-column label="操作" width="100">
            <template slot-scope="scope">
              <el-button @click="handleClick(scope.row)" type="text" size="small">修改</el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-main>
      <el-footer>
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="page"
          :page-sizes="[10, 20, 30, 40,50]"
          :page-size="rows"
          layout="total, prev, pager, next, sizes, jumper"
          :total="total"
        ></el-pagination>
      </el-footer>
    </el-container>
    <!-- 新增/修改门禁弹窗 -->
    <el-dialog title="新增门禁信息" :visible.sync="isAddDialogShow" :before-close="hideAddDialog">
      <el-form :model="addForm" label-width="70px">
        <el-row>
          <el-col span="12">
            <el-form-item label="门禁类别">
              <el-select v-model="addForm.GATE_TYPE">
                <el-option label="区域一" value="shanghai"></el-option>
                <el-option label="区域二" value="beijing"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col span="12">
            <el-form-item label="小区名称">
              <el-select v-model="addForm.AREA_NAME">
                <el-option label="区域一" value="shanghai"></el-option>
                <el-option label="区域二" value="beijing"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col span="12">
            <el-form-item label="楼座名称">
              <el-select v-model="addForm.BUILD_CODE">
                <el-option label="区域一" value="shanghai"></el-option>
                <el-option label="区域二" value="beijing"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col span="12">
            <el-form-item label="单元号">
              <el-select v-model="addForm.UNIT_CODE">
                <el-option label="区域一" value="shanghai"></el-option>
                <el-option label="区域二" value="beijing"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col span="12">
            <el-form-item label="设备编号">
              <el-input v-model="addForm.DEVICE_CODE"></el-input>
            </el-form-item>
          </el-col>
          <el-col span="12">
            <el-form-item label="设备名称">
              <el-input v-model="addForm.DEVICE_NAME" autocomplete="off"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col span="12">
            <el-form-item label="设备厂商">
              <el-input v-model="addForm.DEVICE_MAN" autocomplete="off"></el-input>
            </el-form-item>
          </el-col>
          <el-col span="12">
            <el-form-item label="设备型号">
              <el-input v-model="addForm.DEVICE_MOD" autocomplete="off"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col span="12">
            <el-form-item label="开门方式">
              <el-select v-model="addForm.OPEN_TYPE">
                <el-option label="区域一" value="shanghai"></el-option>
                <el-option label="区域二" value="beijing"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col span="12">
            <el-form-item label="是否开启">
              <el-select v-model="addForm.OPEN_FLAG">
                <el-option label="区域一" value="shanghai"></el-option>
                <el-option label="区域二" value="beijing"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="hideAddDialog()">取 消</el-button>
        <el-button type="primary" @click="hideAddDialog()">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { getSysUserAccountService } from "../../services/basicDataService";
import { getAreaListByDeptCodeService } from "../../services/commonService";
export default {
  name: "AccountSetting",
  data() {
    return {
      total: 0, //门禁总数
      accountList: [], //岗位设置列表
      isAddDialogShow: false, //新增门禁弹窗显示开关
      isScreenShow: false, //高级筛选显示开关
      form: {
        reportName: "",
        reportPhone: "",
        approvalUser: "",
        approvalPost: "",
        approvalType: 0,
        approvalStatus: 0
      },
      addForm: {
        GATE_TYPE: 1,
        AREA_CODE: "迪生山庄",
        BUILD_CODE: "",
        UNIT_CODE: "",
        DEVICE_CODE: "A807D3AEA8FAF",
        DEVICE_NAME: "迪生山庄南门",
        DEVICE_MAN: "令令",
        DEVICE_MOD: "LING-MB-L12",
        OPEN_TYPE: 7,
        OPEN_FLAG: 1
      },
      page: 1,
      rows: 10
    };
  },
  created() {
    this.getSysUserAccount();
    this.getAreaListByDeptCode();
  },
  methods: {
    /* 获取用户列表 */
    getSysUserAccount() {
      let reqParam = {
        operationFlag: 0,
        page: this.page,
        rows: this.rows,
        sort: "name",
        order: "asc"
      };
      getSysUserAccountService(reqParam).then(
        res => {
          console.log(res);
          if (res.resultCode == 0) {
            this.total = res.data.total;
            this.accountList = res.data.list;
          }
        },
        err => {
          this.$message.error("网络请求失败");
        }
      );
    },
    /* 分页改变事件 */
    handleCurrentChange(page){
      console.log(page);
      this.page = page;
      this.getSysUserAccount();
    },
    /* 分页显示数量改变事件 */
    handleSizeChange(rows){
      this.rows = rows;
      this.page = 1;
      this.getSysUserAccount();
    },
    /* 获取小区列表 */
    getAreaListByDeptCode() {
      getAreaListByDeptCodeService().then(
        res => {
          console.log(res);
          if (res.resultCode == 0) {
            this.approveList = res.data.list;
          }
        },
        err => {
          this.$message.error("网络请求失败");
        }
      );
    }
  }
};
</script>

<style scoped lang="scss">
.accountSetting {
  height: 100%;
  background-color: white;
}
.screenPanel {
  text-align: left;
  min-height: 40px;
  padding: 16px 0 0 0;
}
.handlePanel {
  text-align: right;
  // padding: 0 20px;
}
.operatePanel {
  text-align: right;
  margin: 16px 0;
  padding: 0 20px;
}
.el-select {
  width: 100%;
}
.el-form-item__label{
  text-align: left;
}
.el-footer{
  text-align: right;
}
/deep/.el-radio-button__inner {
  background: #d5e7ed;
  border: none;
  border-radius: 0;
  box-shadow: none;
  :hover {
    background: #069dbc;
    color: #fff;
  }
}
/deep/.el-radio-button__orig-radio:checked + .el-radio-button__inner {
  background: #fff;
  color: #069dbc;
  border: none;
  border-radius: 0;
  box-shadow: none;
  :hover {
    background: #069dbc;
    color: #fff;
  }
}
</style>
